export default {
	"planDispatch": {
		"mapPlanning": "การวางแผนแผนที่",
		"addRoute": "ใบตราส่งสินค้าเพิ่มเติม",
		"IdlingRate": "อัตราว่าง",
		"pPunctuality": "อัตราการดำเนินการตามกำหนดเวลา",
		"confirmScheduling": "ยืนยันการจัดกำหนดการ",
		"autoLine": "การวางแผนเส้นทางอัตโนมัติ",
		"operatingTips": "คำแนะนำการใช้งาน",
		"onlyOneRouter": "สามารถเลือกการจัดส่งได้เพียงรายการเดียวเท่านั้น"
	},
	"transportOrderInfo": {
		"needDelivery": "จำเป็นต้องจัดส่ง"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/planDispatch/planDispatch.js